import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DistributionsService } from 'src/app/services/distributions.service';
import { RellenoService } from 'src/app/services/relleno.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-relleno-material',
  templateUrl: './relleno-material.component.html',
  styleUrls: ['./relleno-material.component.scss']
})
export class RellenoMaterialComponent {

  dataMat: any;
  tipoSeleccionado: string = '';
  tipoRelleno: string = '';
  input_ingresa: number = 0;
  total_ingresar: number = 0;
  
    constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      private rellenoServ: RellenoService,
      private dialogRef: MatDialogRef<RellenoMaterialComponent>,
    ) { }
  
    ngOnInit(): void {
      this.dataMat = this.data;

      if (this.dataMat.tipo == 'g') {
        if (this.dataMat.bitPesoUnitario === 1) {
          this.tipoSeleccionado = 'peso';
          this.tipoRelleno = 'peso (kg)';
        } else if (this.dataMat.bitTamanoBatch === 1) {
          this.tipoSeleccionado = 'batch';
          this.input_ingresa = 1;
          //this.total_ingresar = this.dataMat.batch;
          this.tipoRelleno = 'cantidad de batches';
        }
        else{
          this.tipoRelleno = '';
        }
      }

      if(this.dataMat.batch == null){
        this.dataMat.batch = 1;
        this.input_ingresa = 1;
        this.total_ingresar = 1;
      }
      
    }
  
    saveRelleno() {
  
      let newObj = {
        id_rack_material: this.dataMat.id_rack_material,
        total_ingresar: this.resultadoCantidad,
        tipo: this.dataMat.tipo,
        id_mat_camp: this.dataMat.id_mat_camp,
        id_campana: this.dataMat.camp.id
      }
  
      if (this.resultadoCantidad <= 0) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Por favor ingresa una cantidad mayor a 0'
        })
      }
      /* else if(this.resultadoCantidad > (this.dataMat.actual - this.dataMat.en_linea)){
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          html: `
            La cantidad de inventario actual es menor a las unidades a ingresar.<br><br>
            Inventario actual: ${this.dataMat.actual - this.dataMat.en_linea} <br>
            Unidades a ingresar: ${this.resultadoCantidad}
          `
        })
      } */
      else {
        this.rellenoServ.saveRelleno(newObj).subscribe(
          (result: any) => {
            Swal.fire({
              icon: 'success',
              title: 'Guardado',
              text: ''
            }).then(() => {
              this.dialogRef.close({ reload: true });            
            });
          },
          (err: any) => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar'
            });
          }
        );
      }
    }

    onTipoChange() {
      this.dataMat.bitPesoUnitario = this.tipoSeleccionado === 'peso' ? 1 : 0;
      this.dataMat.bitTamanoBatch = this.tipoSeleccionado === 'batch' ? 1 : 0;

      if(this.tipoSeleccionado === 'peso'){
        this.tipoRelleno = 'peso (kg)';
        this.input_ingresa = 0;
        this.total_ingresar = 0;
      }
      else if(this.tipoSeleccionado === 'batch'){
        this.tipoRelleno = 'cantidad de batches';
        this.input_ingresa = 1;
        this.total_ingresar = 0;
      }
      else{
        this.tipoRelleno = 'unidades';
        this.input_ingresa = 0;
        this.total_ingresar = 0;
      }
      
    }

  get resultadoCantidad(): number {
    if (this.dataMat.tipo == 'g') {
      if (this.tipoSeleccionado === 'peso') {
        return Number(Math.round((this.input_ingresa * 10) / (this.dataMat.peso * 10)));
      }
      else if(this.tipoSeleccionado == 'batch'){
        return Number(this.input_ingresa * this.dataMat.batch);
      }
      else {
        return Number(this.input_ingresa);
      }
    }
    else{
      return Number(this.input_ingresa);
    }
  }

  soloEnteros(event: any) {
    const value = event.target.value;
     if (this.tipoSeleccionado != 'peso') {
       event.target.value = value.replace(/[^0-9]/g, '');
       this.input_ingresa = event.target.value;
     }
   
  }

}
